/**
 * Please keep the keys in alphabetical order.
 */
module.exports = {
  AncillaryFunctions: require('./enums/ancillary-functions'),
  BackgroundInfoObjectType: require('./enums/background-info-object-type'),
  CompSearchExecution: require('./enums/comp-search-execution'),
  CompSearchState: require('./enums/comp-search-state'),
  Countries: require('./enums/countries'),
  CountriesWithUniqueMasterFileTemplates: require('./enums/countries-with-unique-master-file-templates'),
  CountriesWithUniquePlanningTemplates: require('./enums/countries-with-unique-planning-templates'),
  CurrencyScale: require('./enums/currency-scale'),
  FinancialAreas: require('./enums/financial-areas'),
  FinancialTypes: require('./enums/financial-types'),
  FineTuningStatus: require('./enums/fine-tuning-status'),
  FunctionsPerformed: require('./enums/functions-performed'),
  HasFailure: require('./enums/has-failure'),
  HasWarning: require('./enums/has-warning'),
  IndustrialCodeTypes: require('./enums/industrial-code-types'),
  InRangeStatus: require('./enums/in-range-status'),
  InternalLocalFileSofEntitiesVisibility: require('./enums/internal-file-sof-entities-visibility'),
  InternalLocalFileTransactionDocumentationVisibility: require('./enums/internal-file-transactions-documentation-visibility'),
  IsRejected: require('./enums/is-rejected'),
  LocationTypes: require('./enums/location-types'),
  Majors: require('./enums/majors'),
  MethodEvaluations: require('./enums/method-evaluations'),
  PbaTbaJurisdictionStatus: require('./enums/pba-tba-jurisdiction-status'),
  PliAverageTypes: require('./enums/pli-average-types'),
  PliTypes: require('./enums/pli-types'),
  PliDisplayFormats: require('./enums/pli-display-formats'),
  TbaPliDisplayFormats: require('./enums/tba-parameter-display-format'),
  PrepareByDateTypes: require('./enums/prepare-by-date-types'),
  PrimaryFunctions: require('./enums/primary-functions'),
  ProductNames: require('./enums/product-names'),
  RangeMethodTypes: require('./enums/range-method-types'),
  RangeTypes: require('./enums/range-types'),
  Regions: require('./enums/regions'),
  RejectionTypes: require('./enums/rejection-types'),
  RejectionGroupTypes: require('./enums/rejection-group-types'),
  ReportDomicileStatuses: require('./enums/report-domicile-statuses'),
  ReportInstanceStatuses: require('./enums/report-instance-statuses'),
  ReportReviewStatuses: require('./enums/report-review-statuses'),
  ReportSectionTemplateOptions: require('./enums/report-section-template-options'),
  ReportTemplates: require('./enums/report-templates'),
  ReportTypes: require('./enums/report-types'),
  ReportType: require('./enums/report-type'),
  ReportVersionStatus: require('./enums/report-version-status'),
  ReportUserDataTypes: require('./enums/report-user-data-type'),
  TopicObjectType: require('./enums/topic-object-type'),
  UsaMethodEvaluations: require('./enums/usa-method-evaluations'),
  UserRoles: require('./enums/user-roles')
};
